import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const kurtosisDescription: CalculatorDescription = {
  title: 'Kurtosis Calculator',
  metaTitle: 'Online Kurtosis Calculator - Measure Distribution Tail Weight',
  description: 'Calculate both kurtosis and relative kurtosis (excess kurtosis) to measure the relative weight of your distribution\'s tails. Identify if your data has more or fewer extreme values compared to a normal distribution.',
  metaDescription: 'Calculate kurtosis and relative kurtosis online. Analyze distribution tail weight and extreme value frequency with our free kurtosis calculator. Statistical analysis made easy.',
  id: CalculatorId.KURTOSIS,
  howTo: {
    title: 'How to Calculate Kurtosis',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically compute both kurtosis and relative kurtosis values',
      'View the distribution type classification and interpretation',
      'Examine the visualization to understand the tail weight of your data distribution'
    ]
  },
  examples: [
    {
      title: 'Test Score Analysis',
      description: 'Analyze the distribution of test scores to understand the frequency of extreme values.',
      dataDescription: 'Sample test scores: 85, 92, 78, 95, 88, 82, 90, 85, 87, 91',
      insights: [
        'Kurtosis of 3 indicates a normal distribution',
        'Relative kurtosis of 0 indicates a normal distribution',
        'Positive relative kurtosis indicates more extreme values than a normal distribution',
        'Negative relative kurtosis indicates fewer extreme values than a normal distribution'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.VARIANCE,
    CalculatorId.INTERQUARTILE_RANGE
  ]
}; 